import { useState, useEffect } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ProcessStepper } from './ProcessStepper';
import { Breadcrumbs } from './Breadcrumbs';
import { getCookie } from '@/lib/getCookie';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [application, setApplication] = useState<any>(null);
  console.log("appl", application)

  useEffect(() => {
    const appDataCookie = getCookie('app_data');

    if (appDataCookie) {
      try {
        setApplication(
          JSON.parse(decodeURIComponent(appDataCookie))
        );
      } catch (error) {
        console.error('Failed to parse application cookie', error);
      }
    }
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      // On desktop, default to open; on mobile, default to closed
      if (!mobile && !sidebarOpen) {
        setSidebarOpen(true);
      } else if (mobile && sidebarOpen) {
        setSidebarOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex flex-1 min-h-0 relative">
        {/* Mobile overlay */}
        {isMobile && sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <Sidebar
          open={sidebarOpen}
          onToggle={() => setSidebarOpen(!sidebarOpen)}
          isMobile={isMobile}
        />

        <main className="flex-1 min-w-0 overflow-auto">
          {application && (
            <div className="px-4 md:px-6 py-1.5 text-sm text-slate-700">
              <div className="flex flex-wrap gap-x-6 gap-y-1">
                <span>
                  <strong>ID:</strong> {application?.ID}
                </span>

                <span>
                  <strong>Application Name:</strong> {application?.Name}
                </span>

                {
                  application?.Category_Name &&
                  <span>
                    <strong>Category Name:</strong> {application?.Category_Name}
                  </span>
                }
                {
                  application?.Sub_Category_Name &&
                  <span>
                    <strong>Sub Category Name:</strong> {application?.Sub_Category_Name}
                  </span>
                }
                {
                  application?.Type_Name &&
                  <span>
                    <strong>Type Name:</strong> {application?.Type_Name}
                  </span>
                }
                {
                  application?.Entity_Name &&
                  <span>
                    <strong>Entity Name:</strong> {application?.Entity_Name}
                  </span>
                }
              </div>
            </div>
          )}

          <Breadcrumbs />

          <div className="p-4 md:p-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
